export default __webpack_public_path__ + "static/media/coaching.56e0f4f1.png";